import React from 'react'

import Image from 'components/shared/Image'

import classnames from 'classnames/bind'
import css from './styles.module.scss'

const cx = classnames.bind(css)

const ImageCard = ({ className, withShadow = true, ...rest }) => {
  return (
    <div className={cx(className, css.ImageCard, { withShadow })}>
      <Image className={css.image} forcedRatio={0.55} {...rest} />
    </div>
  )
}

export default ImageCard
